export default function getClosingParams(values) {
  const resolved = values.resolved === 'resolved';
  return { ...values, resolved };
}
